<router-outlet></router-outlet>
<ng4-loading-spinner [timeout]="50000"> </ng4-loading-spinner>
